import { EBOOK_LISTINGS } from '../data/ebook-metadata';

const meta = EBOOK_LISTINGS.find((e) => e.slug === 'house-points-guide')!;

export function HousePointsGuideContent() {
  return (
    <>
      {/* Hero */}
      <section className="border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16 md:py-24">
          <div className="grid md:grid-cols-3 gap-12 items-center">
            {/* Book Preview */}
            <div className="flex justify-center">
              <div className="relative">
                <div
                  className="w-48 h-64 rounded-xl shadow-lg flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg, #6f71ee 0%, #8183FF 100%)' }}
                >
                  <div className="text-center p-4">
                    <p className="text-white/70 text-xs font-semibold uppercase tracking-wider mb-2">
                      LiveSchool
                    </p>
                    <p className="text-white font-bold text-lg leading-tight">{meta.title}</p>
                  </div>
                </div>
                <div className="absolute left-0 top-3 bottom-3 w-2 bg-purple-800/60 -translate-x-full rounded-l" />
                <div className="absolute right-0 top-2 bottom-2 w-1 bg-gray-200/80 translate-x-full rounded-r" />
                <div className="absolute right-0 top-3 bottom-3 w-1 bg-gray-300/60 translate-x-[calc(100%+4px)] rounded-r" />
              </div>
            </div>

            {/* Content */}
            <div className="md:col-span-2">
              <h1
                className="text-4xl md:text-5xl font-bold mb-4"
                style={{ fontFamily: 'var(--font-poppins), sans-serif', color: '#101e57' }}
              >
                {meta.title}
              </h1>
              <p className="text-xl text-gray-600 mb-8">{meta.description}</p>
              <button
                className="rounded-full px-8 py-4 font-semibold text-white transition-colors cursor-pointer hover:opacity-90"
                style={{ backgroundColor: '#6f71ee' }}
              >
                Download PDF
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Content Placeholder */}
      <section className="border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
          <div className="rounded-xl border border-dashed border-gray-300 p-12 text-center">
            <p className="text-gray-400 text-lg">[Guide content coming soon]</p>
            <p className="text-gray-400 mt-2">
              This is a stub page for the House Points Guide.
            </p>
          </div>

          <div className="mt-12 space-y-8">
            <h2
              className="text-2xl font-bold"
              style={{ fontFamily: 'var(--font-poppins), sans-serif', color: '#101e57' }}
            >
              What&apos;s inside
            </h2>
            <ul className="space-y-3">
              {meta.topics.map((topic, i) => (
                <li
                  key={i}
                  className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all"
                >
                  <span
                    className="w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm text-white"
                    style={{ backgroundColor: '#6f71ee' }}
                  >
                    {i + 1}
                  </span>
                  <span className="text-gray-800">{topic}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
